/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleLeftIcon20Light = forwardRef('ArrowFigureACircleLeftIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M13.5 9.5A.5.5 0 0 0 13 9H6.781l2.54-2.116a.5.5 0 1 0-.641-.768L6.002 8.348a1.5 1.5 0 0 0 0 2.304l2.678 2.232a.5.5 0 0 0 .64-.768L6.781 10H13a.5.5 0 0 0 .5-.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17 9.5a7.5 7.5 0 1 0-15 0 7.5 7.5 0 0 0 15 0ZM9.5 3a6.5 6.5 0 1 1 0 13 6.5 6.5 0 0 1 0-13Z" })));
});
